export const BANNER_ID = 'poalim_mortgage_calculator';
export const BANNER_LINK = 'https://mortgage.bankhapoalim.co.il/ng-portals/dm/he/all-purposes?utm_source=madlan&utm_medium=affiliate&utm_campaign=madlan_mortgage_ao-mort_-_awr_afilliate&utm_id=ounrneq8hmmc8vr2ea&utm_content=calculator';
export const INTEREST_RATE = 5.06;
export const MIN_YEARS = 10;
export const MAX_YEARS = 30;
export const YEARS_STEP = 1;
export const EQUITY_STEP = 50000;
export const MIN_EQUITY_PERCENTAGE = 25;
export const DEFAULT_EQUITY_PERCENTAGE = 50;
export const DEFAULT_YEARS = 20;
export const MIN_EQUITY = 100000;
